module.exports = __webpack_public_path__ + "static/media/play-score-2.ff9fd8d4.png";